import { useEffect, useRef, useState } from "react";

import { cn } from "twyne-new.ui";

import { useInteractionMode, useResponsive } from "@/modules/cms/views/post/components/builder/context";

import Droppable from "./Droppable";

export default function RootBackground({ children, ...props }) {
  const rootRef = useRef(null)
  const [container, setContainer] = useState(null)
  const { value: interactionMode } = useInteractionMode()
  const { useHeightResizer } = useResponsive()

  useEffect(() => {
    setContainer(rootRef.current)
  }, [])

  useHeightResizer(container)

  const classes = INTERACTION_CLASSES[interactionMode]

  return <Droppable {...props} className={cn("w-full h-full shadow-[0_0_20px_rgba(0,0,0,0.13)]", classes)}>
    <div ref={rootRef} className="w-full">
      {children}
    </div>
  </Droppable>
}

const INTERACTION_CLASSES = {
  select: 'cursor-crosshair select-none',
  move: 'cursor-grab',
  zoom: 'cursor-zoom-in',
  'format_painter:past': 'cursor-copy',
}
